module.exports = __webpack_public_path__ + "static/media/agreeableness-spectrum.b4e9d2cb.png";